import { render, staticRenderFns } from "./MyDocument.vue?vue&type=template&id=260cb12a"
import script from "./MyDocument.vue?vue&type=script&lang=js"
export * from "./MyDocument.vue?vue&type=script&lang=js"
import style0 from "./MyDocument.vue?vue&type=style&index=0&id=260cb12a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports